$(window).on("load", function () {
  var swiperInstances = {};

  function loadImagesInItem($item) {
    $item.find("img[data-src]").each(function () {
      var $img = $(this);
      $img
        .attr("src", $img.attr("data-src"))
        .removeAttr("data-src")
        .removeClass("MJ__lazyload");
    });
  }

  function initSwiperForTab(index) {
    if (swiperInstances[index]) return;

    var $item = $(".character__swiper--" + (index + 1));
    if (!$item.length) return;

    loadImagesInItem($item);

    try {
      var thumbSwiper = new Swiper($item.find(".swiper-character-thumb")[0], {
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            direction: "vertical",
            slidesPerView: 4,
          },
        },
      });

      var mainSwiper = new Swiper($item.find(".swiper-character")[0], {
        spaceBetween: 10,
        navigation: {
          nextEl: $item.find(".swiper-button-next")[0],
          prevEl: $item.find(".swiper-button-prev")[0],
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });

      swiperInstances[index] = { main: mainSwiper, thumb: thumbSwiper };
    } catch (e) {
      console.warn("[characters] Swiper init failed for tab " + (index + 1), e);
    }
  }

  $(document).on("click", ".character__tab--item", function (e) {
    e.preventDefault();

    var $tabs = $(".character__tab--item");
    var index = $tabs.index(this);

    if ($(this).hasClass("active")) return;

    $tabs.removeClass("active");
    $(this).addClass("active");

    $(".character__swiper--item").hide();
    var $swiper = $(".character__swiper--" + (index + 1)).show();
    if (index === 4) {
      $(".character__swiper").addClass("tab5");
    }

    if (swiperInstances[index]) {
      swiperInstances[index].main.update();
      swiperInstances[index].thumb.update();
    } else {
      initSwiperForTab(index);
    }
  });

  initSwiperForTab(0);
});
